/*
 * HEXA click analytics
 * Publishes storefront interactions as Shopify custom events. The "GA4 HEXA" custom
 * pixel (Settings > Customer events) subscribes to them and forwards them to GA4,
 * so tracking stays inside Shopify's customer-privacy permissions.
 * Targets are matched by existing markup (hrefs, classes, data attributes); no
 * section markup depends on this file.
 */
(function () {
  if (window.hexaAnalyticsBound) return;
  window.hexaAnalyticsBound = true;

  // [pattern tested against an ancestor's id + classes, reported area]; closest ancestor wins.
  var AREAS = [
    [/sticky-add-to-cart/, 'sticky_bar'],
    [/predictive-search/, 'search'],
    [/hpdp-rel|related/, 'related'],
    [/footer/, 'footer'],
    [/header|menu-drawer/, 'header'],
    [/ecosystem/, 'ecosystem'],
    [/bundle/, 'bundle'],
    [/use[-_]case/, 'use-cases'],
    [/review/, 'reviews'],
    [/faq/, 'faq'],
    [/academy/, 'academy'],
    [/hero/, 'hero'],
    [/hexa[-_]products/, 'products'],
    [/hpdp|product-information/, 'pdp'],
  ];

  function publish(name, data) {
    var api = window.Shopify && window.Shopify.analytics;
    if (!api || typeof api.publish !== 'function') return;
    try {
      api.publish(name, data);
    } catch (e) {}
  }

  function text(el, max) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim().slice(0, max || 100) : '';
  }

  // First known area keyword found in the element's ancestors' classes or ids.
  function area(el) {
    for (var node = el; node && node !== document.body; node = node.parentElement) {
      var hay = ((node.id || '') + ' ' + (typeof node.className === 'string' ? node.className : '')).toLowerCase();
      for (var i = 0; i < AREAS.length; i++) {
        if (AREAS[i][0].test(hay)) return AREAS[i][1];
      }
    }
    return location.pathname.indexOf('/products/') === 0 ? 'pdp' : 'page';
  }

  function pageProduct() {
    if (location.pathname.indexOf('/products/') !== 0) return '';
    return text(document.querySelector('main h1'), 60);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var link = target.closest('a[href]');
    if (link) {
      var href = link.getAttribute('href') || '';
      if (/wa\.me|whatsapp\.com/i.test(href)) {
        publish('hexa_whatsapp_click', { location: link.classList.contains('hexa-whatsapp') ? 'floating' : area(link), product: pageProduct() });
        return;
      }
      if (/apps\.apple\.com/i.test(href) || /play\.google\.com/i.test(href)) {
        publish('hexa_app_store_click', { platform: /apple/i.test(href) ? 'ios' : 'android', location: area(link) });
        return;
      }
      if (/^(tel|mailto):/i.test(href)) {
        publish('hexa_contact_click', { method: href.slice(0, href.indexOf(':')).toLowerCase(), location: area(link) });
        return;
      }
      var match = href.match(/\/products\/([^/?#]+)/);
      if (match && location.pathname.indexOf('/products/' + match[1]) !== 0) {
        publish('hexa_select_item', { item_id: match[1], location: area(link) });
        return;
      }
    }

    var pack = target.closest('[data-hexa-pack-option]');
    if (pack && !pack.disabled) {
      publish('hexa_pack_select', { product: pageProduct(), pack: pack.dataset.label || text(pack, 40) });
      return;
    }

    if (target.closest('[data-hexa-quick-purchase]')) {
      publish('hexa_quick_purchase_click', { product: pageProduct() });
      return;
    }

    var summary = target.closest('summary');
    var details = summary && summary.parentElement;
    if (details && details.tagName === 'DETAILS' && !details.open && text(summary)) {
      var inFaq = !!summary.closest('[class*="faq"]');
      publish(inFaq ? 'hexa_faq_open' : 'hexa_details_open', {
        title: text(summary.querySelector('.hexa-faq__question, .hpdp-acc__title') || summary, 120),
        location: location.pathname.indexOf('/products/') === 0 ? 'pdp' : 'page',
        product: pageProduct(),
      });
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('hexa-bundle__form')) return;
    var card = form.closest('article.hexa-bundle');
    publish('hexa_bundle_add', {
      bundle: text(card && card.querySelector('.hexa-bundle__name'), 60),
      location: location.pathname.indexOf('/products/') === 0 ? 'pdp' : 'page',
      product: pageProduct(),
    });
  }, true);
})();
